import { pgTable, uuid, text, integer, timestamp, index, uniqueIndex, jsonb } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const ECOMMERCE_PRODUCT_STATUSES = ["active", "draft", "archived"] as const;
export type EcommerceProductStatus = (typeof ECOMMERCE_PRODUCT_STATUSES)[number];

export const ecommerceProducts = pgTable(
  "ecommerce_products",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    connectionId: uuid("connection_id").notNull(),
    provider: text("provider").notNull(),
    externalProductId: text("external_product_id").notNull(),
    title: text("title").notNull(),
    handle: text("handle"),
    status: text("status").notNull().default("active"),
    currency: text("currency").notNull().default("USD"),
    priceAmountCents: integer("price_amount_cents").notNull().default(0),
    imageUrl: text("image_url"),
    providerMetadata: jsonb("provider_metadata").$type<Record<string, unknown>>().default({}),
    syncedAt: timestamp("synced_at", tz).notNull().defaultNow(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    uniqueIndex("uq_ecom_products_connection_ext").on(table.tenantId, table.connectionId, table.externalProductId),
    index("idx_ecom_products_tenant").on(table.tenantId),
    index("idx_ecom_products_connection").on(table.tenantId, table.connectionId),
    index("idx_ecom_products_status").on(table.tenantId, table.status),
    index("idx_ecom_products_synced").on(table.tenantId, table.syncedAt),
  ],
);
